// Initialise data store
let data = {
    matrix: {
        name: null,
        trigger: null,
        trigger_alt: null,
        considerations: [],
        decisions: [],
        scoreCard: {},
        riskRating: null,
    }

};

// Load stored data and merge with initialised store
/*
let storedData = localStorage.getItem('data');
if (storedData) {
    storedData = JSON.parse(storedData);
    data = {...data, ...storedData}
}
*/

export default {
    namespaced: true,
    state: {...data},
    mutations: {
        commitMatrix(state, payload) {
            state.matrix = {...payload};
        },
        commitConsiderations(state, payload) {
            state.matrix.considerations = [...payload];
        },
        commitConditions(state, payload) {
            state.matrix.considerations[payload.index]['conditions'] = [...payload.conditions];
        },
        commitDecisionTable(state, payload) {
            state.matrix.decisions = [...payload];
        },
        commitScoreCard(state, payload) {
            state.matrix.scoreCard = {...payload};
        },
        commitEditMatrix(state, payload) {
            state.editMatrix = {...payload};
        },
    },
};
